import { render } from "./PaqueteCreate.vue?vue&type=template&id=7b4a26cf&scoped=true"
import script from "./PaqueteCreate.vue?vue&type=script&lang=js"
export * from "./PaqueteCreate.vue?vue&type=script&lang=js"

import "./PaqueteCreate.vue?vue&type=style&index=0&id=7b4a26cf&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b4a26cf"]])

export default __exports__